import React from "react";
import { Button, ButtonProps } from "@cmp-src/primitives/button";

export type ModalConfirmButtonProps = ButtonProps;

/** The primary button of a modal footer; submits its form. */
export const ModalConfirmButton: React.FC<ModalConfirmButtonProps> = ({
  ...rest
}) => {
  return <Button type="submit" {...rest} />;
};
